import React from "react";
import { getLastMessageSnippet } from "../Pc-and-Large-Screens/utils/ChatUtils";

const ChatItem = ({ chat, isActive, onSelect }) => (
  <div
    className={`chat-item ${isActive ? "active" : ""}`}
    onClick={() => onSelect(chat.user, chat.userId)}
  >
    <div className="profile-picture">
      {chat.profilePicture ? (
        <img src={chat.profilePicture} alt={chat.user} />
      ) : (
        <div className="default-profile-picture"></div>
      )}
    </div>
    <div className="chat-details">
      <span className="chat-user">
        {chat.user}
        {chat.unreadCount > 0 && (
          <span className="unread-badge">{chat.unreadCount}</span>
        )}
      </span>
      <span className="chat-snippet">
        {getLastMessageSnippet(chat.messages)}
      </span>
    </div>
  </div>
);

export default ChatItem;
